var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0C4.32261 0 3.86477 0.193154 3.52721 0.536971C3.18964 0.880787 3 1.3471 3 1.83333V9.16667C3 9.6529 3.18964 10.1192 3.52721 10.463C3.86477 10.8068 4.32261 11 4.8 11H10.2C10.6774 11 11.1352 10.8068 11.4728 10.463C11.8104 10.1192 12 9.6529 12 9.16667V4.04617C11.9999 3.55998 11.8102 3.09374 11.4726 2.75L9.3 0.537167C8.96251 0.193326 8.50475 0.000103835 8.0274 0H4.8Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.66667C0 5.22464 0.189642 4.80072 0.527208 4.48816C0.864773 4.17559 1.32261 4 1.8 4V12.3333H9C9 12.7754 8.81036 13.1993 8.47279 13.5118C8.13523 13.8244 7.67739 14 7.2 14H1.8C1.32261 14 0.864773 13.8244 0.527208 13.5118C0.189642 13.1993 0 12.7754 0 12.3333V5.66667Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cf3127636b6b6bd13049883d41f709ac.svg";
export { ForwardRef as ReactComponent };